import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import useHundredBricksAPI from '@lib/hundredBricksAPI/useHundredBricksAPI';
import { Date as DateParser } from '@types';
import { Bold, Paragraph, Subtitle } from '@components/Styled';
import { toast } from '@components';
import { useRequest } from '@hooks';
import { InactiveAccountLockWrapper, ParagraphGroup, SubmitButton, SupportInfoWrapper } from './InactiveAccountLock.style';
const InactiveAccountLock = ({ email, lastSessionDate }) => {
    const api = useHundredBricksAPI();
    const [response, , error, request] = useRequest(api.authentication.resendInactiveCodeAccess);
    const resendEmailInactiveAccount = async () => {
        request(email);
    };
    const getDateFormatted = () => {
        const formattedDetectedDate = DateParser(new Date(lastSessionDate).getTime());
        const formattedDetectedAtDate = formattedDetectedDate.format('DD MMMM YYYY');
        const formattedDetectedAtTime = formattedDetectedDate.format('hh:mm a');
        return `Detectamos que tu último inicio de sesión fue el ${formattedDetectedAtDate}
      a las ${formattedDetectedAtTime}.`;
    };
    useEffect(() => {
        if (response !== undefined) {
            toast.success('El correo se envió con éxito');
        }
    }, [response]);
    useEffect(() => {
        if (error) {
            toast.danger('Algo salió mal al enviar el correo, inténtalo de nuevo');
        }
    }, [error]);
    return (_jsxs(InactiveAccountLockWrapper, { children: [_jsx(Subtitle, { children: "Sesi\u00F3n cerrada por inactividad" }), _jsxs(ParagraphGroup, { children: [_jsxs(Paragraph, { children: [getDateFormatted(), ' ', _jsx("br", {}), ' ', "Desde entonces, no has accedido a la plataforma."] }), _jsxs(Paragraph, { children: ["Por seguridad y en cumplimiento con la regulaci\u00F3n de la CNBV,", _jsx("br", {}), ' ', "hemos cerrado tu sesi\u00F3n y bloqueado temporalmente el acceso."] }), _jsxs(Paragraph, { children: ["Para volver a ingresar, es necesario validar tu correo electr\u00F3nico.", _jsx("br", {}), ' ', "Te enviamos un correo con las instrucciones para verificar tu identidad", _jsx("br", {}), ' ', "y reactivar tu cuenta."] }), _jsx(Paragraph, { children: "Si no encuentras el correo, puedes volver a enviarlo o contactar a soporte:" })] }), _jsxs(SupportInfoWrapper, { children: [_jsx(Bold, { children: "soporte@100Ladrillos.com" }), _jsx("span", { children: "\u00BFA\u00FAn no llega tu correo? Intenta enviarlo nuevamente:" })] }), _jsx(SubmitButton, { id: "resend-email", onClick: resendEmailInactiveAccount, children: "Enviar" })] }));
};
export default InactiveAccountLock;
